import React from 'react'

function ExpandIcon({ className }) {
  return (
    <svg
      className={className}
      width="17"
      height="10"
      viewBox="0 0 17 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9364 9.56793C15.8276 9.71149 15.6815 9.78121 15.5353 9.78121C15.403 9.78121 15.2708 9.72355 15.1661 9.6069L8.46467 2.1441L1.76459 9.57203C1.54363 9.81813 1.19894 9.80275 0.996002 9.53487C0.792042 9.26826 0.805843 8.85442 1.02628 8.60832L8.09689 0.733322C8.30615 0.500025 8.62582 0.500025 8.83522 0.733322L15.9058 8.60832C16.1234 8.89117 16.1404 9.30133 15.9364 9.56793Z"
        fill="#18181B"
      />
    </svg>
  )
}

export default ExpandIcon
